import React, { useState, useEffect } from 'react';
import { notification } from '../../hocs/notification';

import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';
import Select from 'react-select';
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Input,
    Label,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Badge,
    Alert,
    Spinner,
    InputGroup,
    InputGroupText,
    FormFeedback,
    Progress
} from 'reactstrap';

import {
    MdDeleteForever,
    MdLocationOn,
    MdAssignmentTurnedIn
} from 'react-icons/md';
import {
    FaUser,
    FaPhone,
    FaIdCard,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaMapMarkerAlt,
    FaBuilding,
    FaHome,
    FaTree,
    FaCheckCircle,
    FaTimesCircle,
    FaSave,
    FaArrowLeft,
    FaTrash,
    FaPlus,
    FaKey,
    FaUserCog,
    FaExclamationTriangle,
    FaInfoCircle
} from 'react-icons/fa';

const AssignUserView = ({ user, back, ...props }) => {
    const [loading, setLoading] = useState(false);
    const [assignLoading, setAssignLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(null);

    const [state, setState] = useState('');
    const [district, setDistrict] = useState('');
    const [block, setBlock] = useState('');
    const [village, setVillage] = useState([]);

    const [stateOpt, setStateOpt] = useState([]);
    const [districtOpt, setDistrictOpt] = useState([]);
    const [blockOpt, setBlockOpt] = useState([]);
    const [villageOpt, setVillageOpt] = useState([]);

    const [tableData, setTableData] = useState([]);

    const [password, setPassword] = useState('');
    const [cfmPassword, setCfmPassword] = useState('');
    const [passwordValid, setPasswordValid] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [viewModal, setViewModal] = useState(false);
    const [resetLoading, setResetLoading] = useState(false);

    const [formErrors, setFormErrors] = useState({});
    const [touched, setTouched] = useState({});

    useEffect(() => {
        getAllocationList();
        get_state_list();
    }, []);

    const calculatePasswordStrength = (password) => {
        let strength = 0;
        if (password.length >= 8) strength += 25;
        if (/[a-z]/.test(password)) strength += 25;
        if (/[A-Z]/.test(password)) strength += 25;
        if (/[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password)) strength += 25;
        return strength;
    };

    const handlePasswordChange = (value) => {
        setPassword(value);
        setPasswordStrength(calculatePasswordStrength(value));
        
        if (cfmPassword) {
            setPasswordValid(value === cfmPassword);
        }
    };

    const delete_handler = async (id, rowData) => {
        if (!window.confirm(`Are you sure you want to remove ${rowData.village} from this user's assignments?`)) {
            return;
        }

        setDeleteLoading(id);
        
        try {
            let postData = [{ "map_id": id }];
            await axios({
                method: 'post',
                url: mainurl + 'Master/user_allocation_delete',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let notify = notification({
                message: "Village assignment removed successfully.",
                type: 'success'
            });
            notify();
            getAllocationList();
        } catch (error) {
            let notify = notification({
                message: "Failed to remove assignment. Try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDeleteLoading(null);
        }
    };

    const reset_password_handler = async (e) => {
        e.preventDefault();
        
        if (!passwordValid || !password) {
            let notify = notification({
                message: "Please enter matching passwords.",
                type: 'warn'
            });
            notify();
            return;
        }

        if (password.length < 6) {
            let notify = notification({
                message: "Password must be at least 6 characters long.",
                type: 'warn'
            });
            notify();
            return;
        }

        setResetLoading(true);

        try {
            let postData = [{ "user_id": user.user_code, "password": password }];
            await axios({
                method: 'post',
                url: mainurl + 'Master/user_reset_password',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let notify = notification({
                message: "Password reset successfully.",
                type: 'success'
            });
            notify();
            setViewModal(false);
            setPassword('');
            setCfmPassword('');
            setPasswordValid(false);
            setPasswordStrength(0);
        } catch (error) {
            let notify = notification({
                message: "Password reset failed. Try again.",
                type: 'error'
            });
            notify();
        } finally {
            setResetLoading(false);
        }
    };

    const getAllocationList = async () => {
        setLoading(true);
        
        try {
            let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": user.user_code }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/user_allocation_view',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            if (response.data.length > 0) {
                let list = response.data.map((row, index) => {
                    return {
                        ids: index + 1,
                        district: row.district_name,
                        block: row.block_name,
                        village: row.village_name,
                        map_id: row.user_map_id,
                        action: (
                            <Button
                                color="danger"
                                size="sm"
                                outline
                                disabled={deleteLoading === row.user_map_id}
                                onClick={() => delete_handler(row.user_map_id, row)}
                                className="d-flex align-items-center gap-1"
                            >
                                {deleteLoading === row.user_map_id ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FaTrash size={12} />
                                )}
                                Remove
                            </Button>
                        ),
                        rawData: row
                    };
                });
                setTableData(list);
            } else {
                setTableData([]);
            }
        } catch (error) {
            let notify = notification({
                message: "Failed to load allocation list.",
                type: 'error'
            });
            notify();
            setTableData([]);
        } finally {
            setLoading(false);
        }
    };

    const get_state_list = async () => {
        try {
            let postData = [{ "country_code": "1" }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_state_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            setStateOpt(response.data);
        } catch (error) {
            console.error('Failed to load states');
        }
    };

    const get_dist_list = async (e) => {
        const stateCode = e.target.value;
        setState(stateCode);
        setDistrict('');
        setBlock('');
        setVillage([]);
        setDistrictOpt([]);
        setBlockOpt([]);
        setVillageOpt([]);

        if (!stateCode || stateCode === '0') return;

        try {
            let postData = [{ "state_code": stateCode }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_dist_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            setDistrictOpt(response.data);
        } catch (error) {
            console.error('Failed to load districts');
        }
    };

    const get_block_list = async (e) => {
        const distCode = e.target.value;
        setDistrict(distCode);
        setBlock('');
        setVillage([]);
        setBlockOpt([]);
        setVillageOpt([]);

        if (!distCode || distCode === '0') return;

        try {
            let postData = [{ "dist_code": distCode }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_block_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            setBlockOpt(response.data);
        } catch (error) {
            console.error('Failed to load blocks');
        }
    };

    const get_village_list = async (e) => {
        const blockCode = e.target.value;
        setBlock(blockCode);
        setVillage([]);
        setVillageOpt([]);

        if (!blockCode || blockCode === '0') return;

        try {
            let postData = [{ "block_code": blockCode }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_village_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row) => ({
                value: row.village_code,
                label: row.village_name
            }));

            setVillageOpt(list);
        } catch (error) {
            console.error('Failed to load villages');
        }
    };

    const assign_handler = async (e) => {
        e.preventDefault();
        
        if (!state || !district || !block || village.length === 0) {
            let notify = notification({
                message: "Please select all required fields including at least one village.",
                type: 'warn'
            });
            notify();
            return;
        }

        setAssignLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": user.user_code,
                "state_id": state,
                "district_id": district,
                "block_id": block,
                "panchayat_id": 0,
                "village_list": village
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/user_allocation',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            if (response.data[0]?.json_status === "success") {
                let notify = notification({
                    message: `${village.length} village(s) assigned successfully.`,
                    type: 'success'
                });
                notify();
                getAllocationList();
                
                // Reset form
                setState('');
                setDistrict('');
                setBlock('');
                setVillage([]);
                setDistrictOpt([]);
                setBlockOpt([]);
                setVillageOpt([]);
            } else {
                let notify = notification({
                    message: "Assignment failed. Please try again.",
                    type: 'error'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Assignment failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setAssignLoading(false);
        }
    };

    const select_vill_handler = (selectedOptions) => {
        const villageIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setVillage(villageIds);
    };

    const check_valid = (pass) => {
        setCfmPassword(pass);
        setPasswordValid(password === pass);
    };

    const getPasswordStrengthColor = () => {
        if (passwordStrength <= 25) return 'danger';
        if (passwordStrength <= 50) return 'warning';
        if (passwordStrength <= 75) return 'info';
        return 'success';
    };

    const getPasswordStrengthText = () => {
        if (passwordStrength <= 25) return 'Weak';
        if (passwordStrength <= 50) return 'Fair';
        if (passwordStrength <= 75) return 'Good';
        return 'Strong';
    };

    const columns = [
        {
            name: '#',
            selector: row => row.ids,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaBuilding size={12} />
                    District
                </div>
            ),
            selector: row => row.district,
            sortable: true,
            cell: row => (
                <Badge color="primary" pill className="text-wrap">
                    {row.district}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMapMarkerAlt size={12} />
                    Block
                </div>
            ),
            selector: row => row.block,
            sortable: true,
            cell: row => (
                <Badge color="secondary" pill className="text-wrap">
                    {row.block}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaHome size={12} />
                    Village
                </div>
            ),
            selector: row => row.village,
            sortable: true,
            cell: row => (
                <div className="fw-medium">{row.village}</div>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            {/* User Information Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-gradient-primary text-white">
                    <div className="d-flex align-items-center gap-2">
                        <FaUserCog size={18} />
                        <h5 className="mb-0">User Information</h5>
                    </div>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={8}>
                            <div className="d-flex flex-column gap-3">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="user-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
                                         style={{ width: '50px', height: '50px', fontSize: '18px' }}>
                                        {user.user_name?.charAt(0).toUpperCase() || 'U'}
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-bold">{user.user_name} ({user.user_name_ne})</h6>
                                        <small className="text-muted">User Profile</small>
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <FaIdCard className="text-primary" size={16} />
                                            <span className="fw-medium">User ID:</span>
                                            <Badge color="light" className="text-primary" pill>
                                                {user.user_code}
                                            </Badge>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <FaPhone className="text-success" size={16} />
                                            <span className="fw-medium">Mobile:</span>
                                            <span>{user.user_phone || 'N/A'}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={4} className="text-end">
                            <Button
                                color='warning'
                                size="sm"
                                onClick={() => setViewModal(true)}
                                className="d-flex align-items-center gap-2 ms-auto text-white"
                            >
                                <FaKey size={14} />
                                Reset Password
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Current Assignments Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-white border-bottom">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            <MdLocationOn className="text-primary" size={20} />
                            <div>
                                <h5 className="mb-0">Current Village Assignments</h5>
                                <small className="text-muted">
                                    {tableData.length > 0 ? 
                                        `${tableData.length} village(s) assigned` : 
                                        'No villages assigned'
                                    }
                                </small>
                            </div>
                        </div>
                        {tableData.length > 0 && (
                            <Badge color="info" pill>
                                {tableData.length} Assignments
                            </Badge>
                        )}
                    </div>
                </CardHeader>
                <CardBody className="p-0">
                    {tableData.length === 0 && !loading ? (
                        <Alert color="info" className="m-3 text-center">
                            <FaInfoCircle size={48} className="mb-3 text-muted" />
                            <p className="mb-2">No village assignments found</p>
                            <small>Use the form below to assign villages to this user</small>
                        </Alert>
                    ) : (
                        <DataTable
                            title=""
                            customStyles={custTableStyles}
                            columns={columns}
                            data={tableData}
                            highlightOnHover
                            responsive
                            pagination
                            paginationPerPage={10}
                            progressPending={loading}
                            progressComponent={
                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                    <Spinner color="primary" />
                                    <p className="mt-2 text-muted">Loading assignments...</p>
                                </div>
                            }
                        />
                    )}
                </CardBody>
            </Card>

            {/* Assignment Form Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-gradient-success text-white">
                    <div className="d-flex align-items-center gap-2">
                        <FaPlus size={16} />
                        <h5 className="mb-0">Assign New Villages</h5>
                    </div>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={assign_handler}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label fw-medium">
                                        <FaMapMarkerAlt className="me-2 text-primary" size={14} />
                                        State *
                                    </Label>
                                    <Input
                                        type="select"
                                        value={state}
                                        onChange={get_dist_list}
                                        required
                                    >
                                        <option value="">-- Select State --</option>
                                        {stateOpt.map((stateItem, index) => (
                                            <option key={index} value={stateItem.state_code}>
                                                {stateItem.state_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label fw-medium">
                                        <FaBuilding className="me-2 text-primary" size={14} />
                                        District *
                                    </Label>
                                    <Input
                                        type="select"
                                        value={district}
                                        onChange={get_block_list}
                                        disabled={!state}
                                        required
                                    >
                                        <option value="">-- Select District --</option>
                                        {districtOpt.map((distItem, index) => (
                                            <option key={index} value={distItem.district_code}>
                                                {distItem.district_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label fw-medium">
                                        <FaMapMarkerAlt className="me-2 text-primary" size={14} />
                                        Block *
                                    </Label>
                                    <Input
                                        type="select"
                                        value={block}
                                        onChange={get_village_list}
                                        disabled={!district}
                                        required
                                    >
                                        <option value="">-- Select Block --</option>
                                        {blockOpt.map((blockItem, index) => (
                                            <option key={index} value={blockItem.block_code}>
                                                {blockItem.block_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label fw-medium">
                                        <FaHome className="me-2 text-primary" size={14} />
                                        Villages * (Multiple Selection)
                                    </Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        options={villageOpt}
                                        onChange={select_vill_handler}
                                        placeholder="Select villages..."
                                        isDisabled={!block}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                    {village.length > 0 && (
                                        <small className="text-success mt-1 d-block">
                                            {village.length} village(s) selected
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <hr className="my-4" />
                        
                        <div className="d-flex justify-content-between align-items-center">
                            <Button
                                color="secondary"
                                outline
                                onClick={back}
                                className="d-flex align-items-center gap-2"
                            >
                                <FaArrowLeft size={14} />
                                Back to List
                            </Button>
                            <Button
                                color="success"
                                type="submit"
                                disabled={assignLoading || !state || !district || !block || village.length === 0}
                                className="d-flex align-items-center gap-2 text-white"
                            >
                                {assignLoading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Assigning...
                                    </>
                                ) : (
                                    <>
                                        <MdAssignmentTurnedIn size={16} />
                                        Assign Villages
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>

            {/* Password Reset Modal */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-warning text-white"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaKey size={18} />
                        <div>
                            <h5 className="mb-0">Reset Password</h5>
                            <small>For user: {user.user_name} ({user.user_code})</small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Alert color="warning" className="d-flex align-items-start gap-2">
                        <FaExclamationTriangle className="text-warning mt-1" size={16} />
                        <div>
                            <strong>Password Reset Warning</strong>
                            <p className="mb-0 small">
                                This action will change the user's password. Make sure to inform the user about the new password.
                            </p>
                        </div>
                    </Alert>

                    <Form onSubmit={reset_password_handler}>
                        <Row>
                            <Col md={12} className="mb-3">
                                <Label className="form-label fw-medium">
                                    New Password *
                                </Label>
                                <InputGroup>
                                    <InputGroupText className="bg-light">
                                        <FaLock className="text-muted" size={14} />
                                    </InputGroupText>
                                    <Input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter new password"
                                        value={password}
                                        onChange={(e) => handlePasswordChange(e.target.value)}
                                        required
                                    />
                                    <Button
                                        color="link"
                                        className="border-0"
                                        onClick={() => setShowPassword(!showPassword)}
                                        type="button"
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </Button>
                                </InputGroup>
                                {password && (
                                    <div className="mt-2">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <small className="text-muted">Password Strength:</small>
                                            <Badge color={getPasswordStrengthColor()} pill>
                                                {getPasswordStrengthText()}
                                            </Badge>
                                        </div>
                                        <Progress
                                            value={passwordStrength}
                                            color={getPasswordStrengthColor()}
                                            style={{ height: '4px' }}
                                        />
                                    </div>
                                )}
                            </Col>
                            <Col md={12} className="mb-3">
                                <Label className="form-label fw-medium">
                                    Confirm Password *
                                </Label>
                                <InputGroup>
                                    <InputGroupText className="bg-light">
                                        <FaLock className="text-muted" size={14} />
                                    </InputGroupText>
                                    <Input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        placeholder="Confirm new password"
                                        value={cfmPassword}
                                        onChange={(e) => check_valid(e.target.value)}
                                        valid={cfmPassword && passwordValid}
                                        invalid={cfmPassword && !passwordValid}
                                        required
                                    />
                                    <Button
                                        color="link"
                                        className="border-0"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        type="button"
                                    >
                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                    </Button>
                                </InputGroup>
                                {cfmPassword && (
                                    <div className="mt-1">
                                        {passwordValid ? (
                                            <small className="text-success d-flex align-items-center gap-1">
                                                <FaCheckCircle size={12} />
                                                Passwords match
                                            </small>
                                        ) : (
                                            <small className="text-danger d-flex align-items-center gap-1">
                                                <FaTimesCircle size={12} />
                                                Passwords do not match
                                            </small>
                                        )}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter className="bg-light">
                    <Button
                        color="secondary"
                        outline
                        onClick={() => setViewModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="warning"
                        onClick={reset_password_handler}
                        disabled={resetLoading || !passwordValid || !password}
                        className="d-flex align-items-center gap-2 text-white"
                    >
                        {resetLoading ? (
                            <>
                                <Spinner size="sm" />
                                Resetting...
                            </>
                        ) : (
                            <>
                                <FaKey size={14} />
                                Reset Password
                            </>
                        )}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default AssignUserView;